import * as React from 'react'
import PropTypes from 'prop-types'

import { cn } from '../../lib/utils'

const ScrollableTableContainer = React.forwardRef(({ className, height = 650, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('scrollable-table-container bg-white rounded-lg border border-gray-200', className)}
    style={{ height }}
    {...props}
  >
    {children}
  </div>
))
ScrollableTableContainer.displayName = 'ScrollableTableContainer'
ScrollableTableContainer.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  children: PropTypes.node
}

const ScrollableTable = React.forwardRef(({ className, ...props }, ref) => (
  <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} />
))
ScrollableTable.displayName = 'ScrollableTable'
ScrollableTable.propTypes = {
  className: PropTypes.string
}

const ScrollableTableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead ref={ref} className={cn('sticky top-0 z-10 bg-white [&_tr]:border-b [&_tr]:border-gray-200', className)} {...props} />
))
ScrollableTableHeader.displayName = 'ScrollableTableHeader'
ScrollableTableHeader.propTypes = {
  className: PropTypes.string
}

const ScrollableTableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody ref={ref} className={cn('[&_tr:last-child]:border-0', className)} {...props} />
))
ScrollableTableBody.displayName = 'ScrollableTableBody'
ScrollableTableBody.propTypes = {
  className: PropTypes.string
}

const ScrollableTableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr
    ref={ref}
    className={cn('border-b border-gray-200 transition-colors hover:bg-gray-50 data-[state=selected]:bg-muted', className)}
    {...props}
  />
))
ScrollableTableRow.displayName = 'ScrollableTableRow'
ScrollableTableRow.propTypes = {
  className: PropTypes.string
}

const ScrollableTableHead = React.forwardRef(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={cn(
      'h-12 px-4 text-left align-middle font-medium text-gray-600 [&:has([role=checkbox])]:pr-0',
      className
    )}
    {...props}
  />
))
ScrollableTableHead.displayName = 'ScrollableTableHead'
ScrollableTableHead.propTypes = {
  className: PropTypes.string
}

const ScrollableTableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td ref={ref} className={cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className)} {...props} />
))
ScrollableTableCell.displayName = 'ScrollableTableCell'
ScrollableTableCell.propTypes = {
  className: PropTypes.string
}

export {
  ScrollableTableContainer,
  ScrollableTable,
  ScrollableTableHeader,
  ScrollableTableBody,
  ScrollableTableHead,
  ScrollableTableRow,
  ScrollableTableCell
}
